import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {client} from './client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'urql';
import {AppProvider} from './AppContext';

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <Provider value={client}>
        <BrowserRouter>
          <App/>
        </BrowserRouter>
      </Provider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
